export const loginEN = {
  login: "Log in",
  email: "Email",
  incorrectEmail: "Incorrect email",
  invalidPassword: "Invalid password",
  fillEmail: "Please fill your email",
  password: "Password",
  fillPassword: "Please fill your password",
  leastDigits: "At least 8 digits with character or number",
  confirmPassword: "Confirm password",
  leastLetters: "Please fill at least 8 digits with character and number",
  passwordPlaceholder: "Please fill at least 8 digits with character and number",
  morePassword: "Please fill at more than 8 digits",
  invalidUser: "User not found",
  passwordOrEmailInvalid: "Email or password is incorrect",
  forgetPassword: "Forget password",
  forgetMessage:
    "The system will send you an email to change your password, please confirm your registered email below.",
  back: "Back to log in",
  confirm: "Confirm",
  register: "Register",
  accept: "I agree and accept the terms and conditions of",
  terms: "the terms of use",
  and: "and",
  privacyPolicy: "privacy policy",
  alreadyAccount: "Already have an account ?",
  createNew: "Create new account",
  changePassword: "Change password",
  createPassword: "Create password",
  linkExpired: "This link is expired",
  expiredMessage:
    "The link has expired. Please use the latest link or click request a new link below",
  successChange: "Successful! changed password",
  passwordChange: "Your password is change",
  registerExpired:
    "The registration period has expired You can log in to check your status",
  successfullSend: "Successful! sended an email for change your password",
  failedSend: "Failed! please confirm an email again",
};

export const loginTH = {
  login: "เข้าสู่ระบบ",
  email: "อีเมล",
  incorrectEmail: "อีเมลไม่ถูกต้อง",
  invalidPassword: "รหัสผ่านไม่ถูกต้อง",
  fillEmail: "ระบุอีเมล",
  password: "รหัสผ่าน",
  fillPassword: "ระบุรหัสผ่าน",
  leastDigits: "อย่างน้อย 8 หลัก เลข / อักษร",
  confirmPassword: "ยืนยันรหัสผ่าน",
  leastLetters: "ระบุอย่างน้อย 8 หลัก เป็นตัวเลข และ ตัวอักษร ผสมกัน",
  passwordPlaceholder: "ระบุอย่างน้อย 8 หลัก เป็นตัวเลข และ ตัวอักษร ผสมกัน",
  morePassword: "ระบุรหัสผ่านมากกว่า 8 หลัก",
  invalidUser: "ไม่พบผู้ใช้งาน",
  passwordOrEmailInvalid: "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
  forgetPassword: "ลืมรหัสผ่าน",
  forgetMessage:
    "เราจะส่งอีเมลเพื่อเปลื่ยนรหัสผ่านถึงคุณกรุณายืนยันอีเมลที่ลงทะเบียนด้านล่าง",
  back: "กลับหน้าเข้าสู่ระบบ",
  confirm: "ยืนยัน",
  register: "ลงทะเบียน",
  accept: "ข้าพเจ้าตกลงและยอมรับข้อกำหนดและเงื่อนไขของ",
  terms: "เงื่อนไขการใช้งาน",
  and: "และ",
  privacyPolicy: "นโยบายความเป็นส่วนตัว",
  alreadyAccount: "มีบัญชีแล้ว ?",
  createNew: "สร้างบัญชีใหม่",
  changePassword: "เปลื่ยนรหัสผ่าน",
  createPassword: "สร้างรหัสผ่าน",
  linkExpired: "ลิงก์เปลื่ยนรหัสผ่านหมดอายุ",
  expiredMessage:
    "ลิงก์เปลื่ยนรหัสผ่านหมดอายุแล้ว โปรดใช้ลิงก์เปลื่ยนรหัสผ่านล่าสุด หรือขอลิงก์ใหม่ด้านล่าง",
  successChange: "เปลื่ยนรหัสผ่านสำเร็จ",
  passwordChange: "รหัสผ่านของคุณถูกเปลื่ยนแล้ว",
  registerExpired:
    "หมดช่วงเวลาการลงทะเบียน ผู้เข้าสมัครที่ลงทะเบียนแล้วสามารถเข้าสู่ระบบเพื่อตรวจสอบข้อมูลได้",
  successfullSend: "ส่งอีเมลเปลี่ยนรหัสผ่านไปยังอีเมลคุณสำเร็จ",
  failedSend: "ส่งอีเมลไม่สำเร็จ กรุณายืนยันอีเมลอีกครั้ง",
};

export const footerEN = {
  message1: "This site will available from ",
  message2: "This is application for ",
};

export const footerTH = {
  message1: "เว็บไซต์นี้ใช้งานได้ตั้งแต่วันที่",
  message2: "ใช้สำหรับสมัครเรียน",
};
